import React from 'react';

export default class ResetSuccess extends React.Component {
  render(){
    return (
      <div className="completion-block">
        <h2>Success!</h2>
        <p>A confirmation email has been sent to your account.  Once you verify the reset, your new password will be activated </p>
      </div>
    );
  }
}
